

































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Product } from '../../modules/class/ProductCategory'
import BookmarkInCard from './BookmarkInCard.vue'
import QuickViewModal from '../ProductCategory/QuickViewModal.vue'
import { PItem } from '@/modules/class/Item'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: { BookmarkInCard, QuickViewModal, RemoveTag }
})
export default class ProductCard extends Vue {
  // ------------------------------------------------------------------------------------------------
  // props
  // 表示対象となる製品
  @Prop({ required: true }) private product!: Product
  @Prop({ required: true }) private productCategory!: PItem
  @Prop({ default: false }) private selected!: boolean
  @Prop({ default: false }) private showCheckbox!: boolean

  // ------------------------------------------------------------------------------------------------
  // data

  // QuickViewの表示可否
  private showQuickViewModal = false

  // ------------------------------------------------------------------------------------------------
  // computed

  /**
   * ブックマークアイコンを表示するかを判定
   */
  get showBookmarkIcon(): boolean {
    return window.iwgp.useMemberShip ?? false
  }

  /**
   * 特殊な製品か判定（製品カテゴリが製品として表示できるため）
   */
  private get isSpecialProd() {
    return this.product.tabs
      ? Object.keys(this.product.tabs).length === 0
      : true
  }

  /**
   * QuickViewに渡すときのパラメータ
   */
  get quickViewParams() {
    return {
      product_name: this.product.name,
      product_category: this.productCategory.name ?? ''
    }
  }
}
